function gcd(a: number, b: number) {
	if (b < 0.0000001) return a;
	return gcd(b, Math.floor(a % b));
}

export default gcd;
